import { ILangdklass } from "../../models/IProduktdefinition";

export class Langdklass {
    overmal: number;
    startlangd: number;
    stolpMaxRotdiameter: number;
    stolpMinRotdiameter: number;
    dirty = false;
    constructor(model: ILangdklass) {
        this.overmal = model.overmal;
        this.startlangd = model.startlangd;
        this.stolpMaxRotdiameter = model.stolpMaxRotdiameter;
        this.stolpMinRotdiameter = model.stolpMinRotdiameter;
    }
}
